"use client"

import { AlertTriangle, Check, Lock, Navigation } from "lucide-react"
import styles from "../css/driver.module.css"

const VARIANTS = {
  done: { className: "pillDone", Icon: Check, label: "Delivered" },
  current: { className: "pillCurrent", Icon: Navigation, label: "Up next" },
  locked: { className: "pillPending", Icon: Lock, label: "Locked" },
  failed: { className: "pillFailed", Icon: AlertTriangle, label: "Not delivered" },
}

/**
 * Status of a stop. Carries an icon as well as colour so the state is still
 * readable in sun glare and for colour-blind users.
 */
export default function StatusPill({ status, label }) {
  const variant = VARIANTS[status] || VARIANTS.locked
  const { Icon } = variant

  return (
    <span className={`${styles.pill} ${styles[variant.className]}`}>
      <Icon size={13} aria-hidden="true" />
      {label || variant.label}
    </span>
  )
}
